function parseForValidationError(string: string): string | undefined {
  return (string.match(/"message":"(.*?)"/) ?? [])[1]
}

export default parseForValidationError
